export default __webpack_public_path__ + "static/media/01.7e10f751.jpg";